function pn_init() {
    /* Priority Navigation */
    var wrapper1 = document.querySelector('.main-navbar__menu-list');
    var wrapper = document.querySelector('nav');

    if (wrapper1 === null) {
        setTimeout(pn_init, 1000);
    } else {
        var mainNav = priorityNav.init({
            mainNavWrapper: '.main-navbar__nav', // mainnav wrapper selector (must be direct parent from mainNav)
            mainNav: '.main-navbar__menu-list', // mainnav selector. (must be inline-block)
            navDropdownClassName: 'main-navbar__dropdown', // class used for the dropdown - this is a class name, not a selector
            navDropdownToggleClassName: 'main-navbar__dropdown-icon', // class used for the dropdown toggle - this is a class name, not a selector
            navDropdownLabel: '', // Text that is used for the dropdown toggle
            navDropdownBreakpointLabel: '', //button label for navDropdownToggle when the breakPoint is reached
            breakPoint: 426, //amount of pixels when all menu items should be moved to dropdown to simulate a mobile menu
            throttleDelay: 50, // this will throttle the calculating logic on resize because i'm a responsible dev.
            offsetPixels: 100, // increase to decrease the time it takes to move an item
            count: true, // prints the amount of items are moved to the attribute data-count to style with css counter
        });
        document.querySelector('.main-navbar__menu-list').classList.remove('hidden-input');

        document
            .querySelector('ul.main-navbar__dropdown.priority-nav__dropdown')
            .addEventListener('click', function (e) {
                if (e.target.tagName === 'A') {
                    if (e.target.parentNode.classList.contains('menu-item-not-clickable')) {
                        e.preventDefault();
                    } else {
                        document.querySelector('button.priority-nav__dropdown-toggle').classList.remove('is-open');
                        document.querySelector('.main-navbar__nav').classList.remove('is-open');
                        document.querySelector('ul.main-navbar__dropdown').classList.remove('show');
                        document.querySelector('ul.main-navbar__dropdown').setAttribute('aria-hidden', 'true');
                    }
                }
            });
    }
    /* Priority Navigation END */
}

pn_init();
